import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { FieldInputProps, FieldMetaState, useForm } from 'react-final-form';
import { getErrorMessage } from 'utilities/form';

interface IProps {
  className?: string;
  children: ReactNode;
  withFixedError?: boolean;
  input: FieldInputProps<any>;
  meta: FieldMetaState<any>;
  disableModifiedMutator?: boolean;
}

const FormElementWrapper = ({
  className,
  children,
  withFixedError = true,
  meta,
  input,
  disableModifiedMutator
}: IProps) => {
  const form = useForm();
  const errorMessage = getErrorMessage(meta);
  return (
    <div
      className={className}
      onBlur={() => {
        input.onBlur();
        if (!disableModifiedMutator && form.mutators.setModifiedSinceLastBlur) {
          form.mutators.setModifiedSinceLastBlur(input.name, false);
        }
      }}
      onFocus={input.onFocus}
    >
      {children}
      {withFixedError && (
        <MessageWrapper>
          <Error data-testid="inputMessage">{errorMessage}</Error>
        </MessageWrapper>
      )}
    </div>
  );
};

export default FormElementWrapper;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  font-size: 1.3rem;
`;

const Error = styled.p`
  min-height: 1.8rem;
  color: ${({ theme }) => theme.colors.error};
  word-break: break-word;
`;
